import { useState, useEffect } from 'react';
import { Table, Select, Button, Modal, Form, Input, Tag } from 'antd';
import { getData } from '../api/api';
import { SearchOutlined } from '@ant-design/icons';
const { Search } = Input;
const BankAccounts = () => {
    const [data, setData] = useState([]);
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [filters, setFilters] = useState({});
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();

    const columns = [
        {
            title: '№',
            key: 'index',
            width: 60, // Aniqlik uchun kenglik
            render: (_, __, index) => index + 1 + (pagination.current - 1) * pagination.pageSize,
        },
        { title: 'Nomi', dataIndex: 'name', key: 'name', width: 150 },
        { title: 'Bank nomi', dataIndex: 'bankName', key: 'bankName', width: 150 },
        { title: 'Hisob raqam', dataIndex: 'bankAccount', key: 'bankAccount', width: 200 }, // Uzunroq bo'lishi mumkin
        { title: 'MFO', dataIndex: 'bankMfo', key: 'bankMfo', width: 120 },
        { title: 'TIN(PINFL)', dataIndex: 'tin', key: 'tin', width: 120 },
        { title: 'Partner Nomi', dataIndex: 'partnerName', key: 'partnerName', width: 200 },
        { title: 'Yaratilgan vaqti', dataIndex: 'createdAt', key: 'createdAt', width: 200 },
        { title: `O'zgartirilgan vaqti`, dataIndex: 'updatedAt', key: 'updatedAt', width: 200 },
        {
            title: 'Holati',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (status) =>
                status === 0 ? (
                    <Tag color="green">Faol</Tag>
                ) : (
                    <Tag color="red">Nofaol</Tag>
                ),
        },
        // {
        //     title: 'Amallar',
        //     key: 'actions',
        //     width: 200,
        //     render: (_, record) => (
        //         <>
        //             <Button size="small" onClick={() => handleUpdate(record)}>
        //                 O'zgartirish
        //             </Button>
        //             <Button size="small" danger onClick={() => handleDelete(record.id)} style={{ marginLeft: 8 }}>
        //                 O'chirish
        //             </Button>
        //         </>
        //     ),
        // },
    ];

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getData('/admin/bank-account-list-by-filter', {
                page: pagination.current - 1, // Backend uchun 0 dan boshlanadi
                size: pagination.pageSize,
                status: -1, // Default status
                ...filters,
            });
            setData(response.data?.data?.content || []);
            setPagination({
                ...pagination,
                total: response.data?.data?.totalCount,
            });
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const getPartners = async () => {
        try {
            const response = await getData('/admin/partner-list-by-filter', {
                page: 0,
                size: 100000, // Keyinchalik yangi API chiqadi
                status: -1, // Default status
            });
            setPartners(response.data?.data?.content || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
        if (!partners || partners.length === 0) {
            getPartners();
        }
    }, [pagination.current, pagination.pageSize, filters]);

    const handleTableChange = (newPagination) => {
        setPagination(newPagination);
    };

    const handleFilter = (values) => {
        setFilters(values);
        setPagination({ ...pagination, current: 1 }); // Filtr o'zgarganda 1-sahifaga qaytish
    };

    const handleCreate = async (values) => {
        // await createData('/dashboard', values);
        // fetchData();
        // setIsModalVisible(false);
        // form.resetFields();
    };

    const handleUpdate = async (record) => {
        // await updateData('/dashboard', record.id, record);
        // fetchData();
    };

    const handleDelete = async (id) => {
        // await deleteData('/dashboard', id);
        // fetchData();
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <h2 style={{ margin: 0 }}>Bank Hisob Raqamlar</h2>
                {/*<Button type="primary" onClick={showModal}>*/}
                {/*    Hisob Raqam qo'shish*/}
                {/*</Button>*/}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
                <Select
                    style={{ width: 120 }}
                    defaultValue={null}
                    onChange={(value) => handleFilter({ ...filters, partnerId: value })}
                    size="middle"
                    showSearch
                    filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    notFoundContent={'Not found'}
                    dropdownStyle={{ zIndex: 9999 }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                >
                    <Select.Option value={null}>Partnerlar</Select.Option>
                    {partners?.map((value) => (
                        <Select.Option key={value.id} value={value.id}>
                            {value.name}
                        </Select.Option>
                    ))}
                </Select>

                <Search
                    placeholder={"Name,bank account, tin, bank name bo'yicha qidirish"}
                    allowClear
                    enterButton={<SearchOutlined />}
                    size="middle"
                    style={{ width: 300 }}
                    onSearch={(val) => handleFilter({ ...filters, search: val })}
                />
            </div>
            <Table
                columns={columns}
                dataSource={data}
                pagination={{
                    ...pagination,
                    showTotal: (total) => `Jami: ${total} ta`,
                }}
                loading={loading}
                onChange={handleTableChange}
                rowKey="id"
                scroll={{ x: 'max-content' }} // Gorizontal scroll uchun
            />
            <Modal
                title="Ma'lumot qo'shish"
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form} onFinish={handleCreate} layout="vertical">
                    <Form.Item
                        name="name"
                        label="Nomi"
                        rules={[{ required: true, message: "Iltimos, nomini kiriting!" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Qo'shish
                        </Button>
                        <Button style={{ marginLeft: 8 }} onClick={handleCancel}>
                            Bekor qilish
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default BankAccounts;